import { ThemeProvider } from "@mui/material/styles";
import { Provider as AlertProvider, positions, transitions } from "react-alert";
//@ts-ignore//
import AlertTemplate from "react-alert-template-basic";
import Rountes from "./Routes/Route";
import theme from "./shared/components/Layouts/theme";
//styles
import "./App.scss";
import { useTimedPolling } from "./useTimedPolling";

const options = {
  position: positions.TOP_CENTER,
  timeout: 6000,
  offset: "30px",
  transition: transitions.SCALE,
  containerStyle: {
    zIndex: 10000,
  },
};

function App() {
  useTimedPolling();
  return (
    <AlertProvider template={AlertTemplate} {...options}>
      <ThemeProvider theme={theme}>
        <Rountes />
      </ThemeProvider>
    </AlertProvider>
  );
}

export default App;
